import { StatTable } from "components/StatsTable/StatTable";
import { StatTableColumn } from "components/StatsTable/StatTableColumn";
import { Match } from "model/Match/Match";
import { selectWithDisplay } from "../Shared";
import { useAppSelector } from "app/hooks";
import {
  calculateSacSeasonRecords,
  SacSeasonRecordWithDisplay,
} from "model/Records old/SacSeasonRecord";

interface Props {
  matches: Match[];
  rosterIds: string[];
  tournamentId: string;
  primaryColor?: string;
  secondaryColor?: string;
}

export const SacSeasonTable = ({
  matches,
  rosterIds,
  tournamentId,
  primaryColor,
  secondaryColor,
}: Props) => {
  const records = calculateSacSeasonRecords(rosterIds, matches) ?? [];

  const recordsWithDisplay = useAppSelector((state) =>
    selectWithDisplay(state, records, tournamentId)
  );

  const columns: StatTableColumn<SacSeasonRecordWithDisplay>[] = [
    {
      type: "Position",
      sortable: true,
      positionGetter: (arg) => arg.record.position,
    },
    {
      type: "OrgLogoName",
      sortable: true,
      orgIdGetter: (arg) => arg.orgId,
      nameGetter: (arg) => arg.displayName,
    },
    {
      type: "Number",
      header: "Played",
      sortable: false,
      valueGetter: (arg) => arg.record.wins + arg.record.loses,
      fractionDigits: 0,
    },
    {
      type: "Text",
      header: "W - L",
      title: "Win Loss Record",
      sortable: false,
      textGetter: (arg) => `${arg.record.wins} - ${arg.record.loses}`,
    },
  ];

  return (
    <StatTable
      thinner={true}
      stats={recordsWithDisplay}
      columns={columns}
      keyGetter={(arg) => arg.displayName}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      paginationAmount={25}
      searchFunction={(arg, searchText) =>
        arg.displayName?.toLowerCase()?.includes(searchText.toLowerCase()) ??
        false
      }
      searchPlaceholder="Search by driver name"
    />
  );
};
